window.Limecraft = window.Limecraft || {};
window.Limecraft.simpleBind = window.Limecraft.proxy || function(fn, context) {
    var fixedArgs;
    fixedArgs = Array.prototype.slice.call(arguments, 2);
    return function () {
        if (context === null) {
            context = this; //support partial application without changing context
        }
        return fn.apply(context, fixedArgs.concat(Array.prototype.slice.call(arguments, 0)));
    };
};
window.Limecraft.Log = window.Limecraft.Log || {
    log: console.log,
    debug: console.debug,
    warn: console.warn
};
window.Limecraft.Player = function (options) {
    this.options = options || {};
    this.init();
};

window.Limecraft.Player.getApiScriptUrl = function () {
    var scripts, src, i, apiScriptUrl;
    scripts = document.getElementsByTagName("script");
    for (i = 0; i < scripts.length; i += 1) {
        src = scripts[i].src;
        if (src.indexOf("player-api.js") > 0) {
            apiScriptUrl = src;
        }
    }
    return apiScriptUrl;
};

window.Limecraft.Player.prototype.init = function () {
    var embedHtmlUrl, apiScriptUrl;
    apiScriptUrl = window.Limecraft.Player.getApiScriptUrl();
    window.Limecraft.Log.debug("api script url is " + apiScriptUrl);
    this.el = document.querySelector(this.options.selector);
    if (!this.el) {
        throw "Element not found";
    }
    this.el.innerHTML = "<iframe allowfullscreen src=\"\" width=\"100%\" height=\"100%\"></iframe>";

    this.iframe = document.querySelector(this.options.selector + " iframe");
    if (!this.iframe) {
        throw "Iframe not created";
    }

    // Setup an event listener that calls receiveMessage() when the window
    // receives a new MessageEvent.
    window.addEventListener("message", window.Limecraft.simpleBind(this.receiveMessage, this));

    //guess the embed.html url
    if (this.options.embedHtmlUrl) {
        embedHtmlUrl = this.options.embedHtmlUrl;
    } else if (apiScriptUrl) {
        embedHtmlUrl = apiScriptUrl.replace("player-api.js", "embed.html");
    } else {
        embedHtmlUrl = "https://platform.limecraft.com/player/embed.html";
    }
    if (this.options.embedOptions && embedHtmlUrl.indexOf("#") < 0) {
        embedHtmlUrl += "#" + btoa(JSON.stringify(this.options.embedOptions));
    }
    this.iframe.src =  embedHtmlUrl;
};
window.Limecraft.Player.prototype.receiveMessage = function (e) {
    var data;
    try {
        data = JSON.parse(e.data);
    } catch (ex) {
        window.Limecraft.Log.warn(ex);
    }
    if (typeof data !== "object") {
        return;
    }
    if (this.options.onReceiveRawMessage) {
        this.options.onReceiveRawMessage(data);
    }
    if (data.status === "page-load") {
        if (this.options.onPlayerReady) {
            this.options.onPlayerReady(this);
        }
    } else if (data.status === "player-loaded") {
        if (this.options.onMediaLoaded) {
            this.options.onMediaLoaded(this, data);
        }
    } else if (data.type === "player-event") {
        if (this.options.onPlayerEvent) {
            this.options.onPlayerEvent(this, data.eventName, data.args);
        }
    }
};
window.Limecraft.Player.prototype.postMessage = function (data) {
    data.component = "limecraft-player-api";
    this.iframe.contentWindow.postMessage(JSON.stringify(data), "*");
};
window.Limecraft.Player.prototype.playerCommand = function (method) {
    this.postMessage({
        type: "playerCommand",
        method: method,
        args: Array.prototype.slice.call(arguments, 1)
    });
};

window.Limecraft.Player.prototype.addListener = function (eventName, options) {
    options = options || {};
    this.postMessage({
        type: "addListener",
        eventName: eventName,
        isVideoEvent: options.isVideoEvent
    });
};
window.Limecraft.Player.prototype.removeListener = function (eventName, options) {
    options = options || {};
    this.postMessage({
        type: "removeListener",
        eventName: eventName,
        isVideoEvent: options.isVideoEvent
    });
};
window.Limecraft.Player.prototype.setPlaylistToQuery = function (options) {
    options = options || {};
    this.postMessage({
        type: "query",
        options: options
    });
};
window.Limecraft.Player.prototype.setHeaderTitle = function (options) {
    options = options || {};
    this.postMessage({
        type: "setHeaderTitle",
        options: options
    });
};

(function () {
    var mapping, prop;

    //map player calls to API
    mapping = {
        "set": "set",
        "setSources": "setSources",
        "seekFrames": "seek",
        "seek": "seekSeconds",
        "seekRelativeFrames": "seekRelative",
        "seekRelative": "seekRelativeSeconds",
        "pluginCall": "pluginCall",
        "resize": "resize"
    };
    for (prop in mapping) {
        if(!mapping.hasOwnProperty(prop)) continue;
        window.Limecraft.Player.prototype[prop] = window.Limecraft.simpleBind(window.Limecraft.Player.prototype.playerCommand, null, mapping[prop]);
    }

    //map pluginCalls to API
    mapping = {
        "play": "controls.playNoToggle",
        "togglePlayPause": "controls.play",
        "pause": "controls.pause",
        "faster": "controls.faster",
        "slower": "controls.slower",
        "playSelection": "controls.playSelection",
        "nextFrame": "controls.next-frame",
        "previousFrame": "controls.previous-frame",
        "playlistPrevious": "playlist.previous",
        "playlistNext": "playlist.next",
        "setPlaylist": "playlist.resetPlaylist",
        "osdShow": "osd.show",
        "osdHide": "osd.hide",
        "timecodeToggle": "overlayTimecode.toggle",
        "timecodeShow": "overlayTimecode.show",
        "timecodeHide": "overlayTimecode.hide",
        "setRotation": "rotate.setRotation",
        "setFlipHorizontal": "rotate.setFlipHorizontal",
        "setFlipVertical": "rotate.setFlipVertical"
    };
    for (prop in mapping) {
        if(!mapping.hasOwnProperty(prop)) continue;
        window.Limecraft.Player.prototype[prop] = window.Limecraft.simpleBind(window.Limecraft.Player.prototype.pluginCall, null, mapping[prop]);
    }
})();

if (window.onLimecraftPlayerAPIReady) {
    window.onLimecraftPlayerAPIReady();
}
